import { render, staticRenderFns } from "./InputMTimeAllocation.vue?vue&type=template&id=b12dc458&scoped=true"
import script from "./InputMTimeAllocation.vue?vue&type=script&lang=js"
export * from "./InputMTimeAllocation.vue?vue&type=script&lang=js"
import style0 from "./InputMTimeAllocation.vue?vue&type=style&index=0&id=b12dc458&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b12dc458",
  null
  
)

export default component.exports